import FooterNavigation from './nav/FooterNavigation';
import ContactHotline from '../features/contact/ContactHotline';
import SocialLinks from '../features/socialLinks/SocialLinks';
import { Grid, Row, Col } from '../../utils/grid/Grid';

import './footer.css';

export default function Footer(): JSX.Element {
  return (
    <footer className="footer" id="content-footer">
      <Grid>
        <Row>
          <Col xs={12}>
            <ContactHotline />
            <SocialLinks />
            <FooterNavigation />
          </Col>
        </Row>
      </Grid>
    </footer>
  );
}
